import { CreditCard } from "lucide-react";
import { Container } from "@/components/layout/Container";
import { BillingPanel } from "@/components/settings/BillingPanel";

export function BillingPage() {
  return (
    <Container size="md" className="py-8 sm:py-12">
      <div className="mx-auto max-w-2xl">
        <header className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-soft">
            <CreditCard className="h-5 w-5 text-brand" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-semibold">Billing</h1>
            <p className="text-sm text-text-muted">Your subscription and payment history.</p>
          </div>
        </header>

        <div className="mt-8">
          <BillingPanel />
        </div>
      </div>
    </Container>
  );
}
